import { render } from "./CurrentsTable.vue?vue&type=template&id=65eff444&scoped=true&ts=true"
import script from "./CurrentsTable.vue?vue&type=script&lang=ts"
export * from "./CurrentsTable.vue?vue&type=script&lang=ts"

import "./CurrentsTable.vue?vue&type=style&index=0&id=65eff444&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65eff444"]])

export default __exports__